<app-sidenav></app-sidenav>
  <div class="content" *ngIf="isDesktop" >
    
    <div class="about-content">
      <ng-container *ngIf="profile | async as profile">

 
      <div class="about-img" data-class="art" *ngFor="let p of profile">
            
                <app-image [baseUrl]="p.image.baseUrl"></app-image>
              
               
          </div>
     
      
    </ng-container>
    
      <div class="publications">
        <h4>Kathryn Elisabeth Lovejoy (1967) – AUSTRALIA <br></h4>
        <p>  I was born in Boroko, Port Moresby, Papua New Guinea in November 1967. I moved to Australia with my family after the Independence of Papua New Guinea in 1975. I have practiced art all of my life and established a professional career in 2007.
          <br><br>
          I specialise in ex-libris (bookplate) design, children’s illustrative paintings and themed art. My creative process involves hand-painted works with professional water colours, acrylics and inks, using fine German Hahnemuhle archival canvases and 100% cotton Hahnemuhle papers. 
          <br><br>
          Archival standard reproduction of ex-libris (bookplate) designs and limited edition prints are carried out by my local Brisbane printmaker, whom I have had the pleasure of working with for more than a decade. Colour and capture of the finest detail, with respect to the original hand-painted design, is superb.
          <br><br>
          With regards to commission work, please feel free to email me about the subject you are interested in. As with all commissions, I will collaborate with you individually and with discretion, so that we can work within your means to create a work of art that you will treasure.
          <br><br>
          Sincerely, <br>
          Kathryn </p>

          

         
      <h4>Member of</h4>
          <ul>
            <li> The New Australian Bookplate Society “Reviving the lost art of Bookplates”<a href="http://www.bookplatesociety.org.au" target="_blank"> http://www.bookplatesociety.org.au</a> </li>
          </ul>
      <h4>Featured in</h4>
      <ul> 
       <li> 2022 - Exhibit : 1st International Redhood Artstudio Graphic Competition on ex-Libris “Make Love NOT WAR”, Poland.
          We invite you to a virtual exhibition.<a href=" https://www.artsteps.com/view/6263e037caf31468e12dfaeb" target="_blank"> Click here to view </a></li> 
          <li>2021 - DIPLOMA in the International Bookplate Competition TRAKAI 700. IN SEARCH OF IDENTITY: TRAKAI RESIDENT’S DNA, Trakai History Museum, Nr. TDNR 00042, Trakai, 2021 07 29</li>
          <li>2021 - selected for the XVII International Ex Libris - Ex Trains competition and entered the Permanent Collection of the Cabinet of Lyuben Karavelov Regional Library - Ruse, Bulgaria</li>
          <li>2021 - The Splendour of Modern Heraldic Bookplate Artists Volume 4, Compiled by Dr Bernard A. Juby, Hon. F.H.S., 
            ISBN : 9-781667-157832, France</li>
          <li>2017 - Muestra Internacional De Ex Libris, Seres Fantasticos Que Habitan “El
          Bosque De La Utopia”, Zacatecas, Mexico, 2017</li>
          <li>2017 - SHORTLIST The Wilderness Society of Australia Environment Award for Children’s Literature - "The Cassowary’s Gift”</li>
          <li>2016 - The Cassowary’s Gift by Pam Skadins, illustrated by Kathryn Lovejoy ISBN : 9781925117578, Australia</li>
          <li>2015 - Miedzynarodowa Wystawa Ekslibrisow, Drogi Do Wolnosci, Ekslibrisyrysunek, Grafika, ISBN : 978-83-919987-6-2, Poland, 2015</li>
          <li>2014 - International Contemporary Ex-Libris Artists/-Modern Women Bookplate Designers, published in Portugal 2014 by Artur Mario da Mota Miranda</li>
          <li>2014 - The Artist Showcase, Magazine issue # Spring, Pittsford, NY14534</li>
          <li>2014 - International Contemporary Masters Volume IX, published by World
             Wide Art Books Inc. Santa Barbara CA 93101, USA, 2014</li>
          <a href=" https://www.theleader.com.au/story/1659862/literary-art-formrevived-
          with-bookplates-on-show/" target="_blank"><li> 2013 - The Kogarah Library, July, 2013, Leader
          https://www.theleader.com.au/story/1659862/literary-art-formrevived-
          with-bookplates-on-show/</li>  </a>
          <li>2013 - International Contemporary Masters Volume VII, published by World
              Wide Art Books Inc. Santa Barbara CA 93101 USA, 2013</li>
          <li>2012 - Eileen Webber’s Book of Family and Social History, Special Edition
              noting appreciation for her commissioned ex-libris design, Australia</li>
          <li>2012 - Bookplate Artists and Their Bookplates by Andrew G Peake, published by Tudor Australia Press, 2012, Standard Edition : ISBN - 978-0-9873119-0-
              0, De Luxe Edition : ISBN - 978-0-9873119-1-7</li>
          <li>2012 - Australian Artist, Magazine Issue #341, 2012</li>
          <li>2012 - OUTthere + Regional Business Review, The In-flight magazine of Skytrans April/May, Australia, 2012</li>
          <li>2010 - Important World Artists Volume I, published by World Wide Art Books
             Inc. Santa Barbara CA 93101, USA</li>



        </ul>
      </div>
     
    </div>
  </div>
  <div class="content" *ngIf="isIpad">
    
    <div class="ipad-about-content">
      <div></div>
    <div>
      <ng-container *ngIf="profile | async as profile">

 
      <div class="ipad-about-img" data-class="art" *ngFor="let p of profile">
            
                <app-image [baseUrl]="p.image.baseUrl"></app-image>
           
          </div>
     
      
    </ng-container>
    
      <div class="ipad-publications">
          <h4>Kathryn Elisabeth Lovejoy (1967) – AUSTRALIA <br><br></h4>
          <p>  I was born in Boroko, Port Moresby, Papua New Guinea in November 1967. I moved to Australia with my family after the Independence of Papua New Guinea in 1975. I have practiced art all of my life and established a professional career in 2007.
            <br><br>
            I specialise in ex-libris (bookplate) design, children’s illustrative paintings and themed art. My creative process involves hand-painted works with professional water colours, acrylics and inks, using fine German Hahnemuhle archival canvases and 100% cotton Hahnemuhle papers. 
            <br><br>
            Archival standard reproduction of ex-libris (bookplate) designs and limited edition prints are carried out by my local Brisbane printmaker, whom I have had the pleasure of working with for more than a decade. Colour and capture of the finest detail, with respect to the original hand-painted design, is superb.
            <br><br>
            With regards to commission work, please feel free to email me about the subject you are interested in. As with all commissions, I will collaborate with you individually and with discretion, so that we can work within your means to create a work of art that you will treasure.
            <br><br>
            Sincerely, <br>
            Kathryn </p>
  

        <h4>Member of</h4>
            <ul>
              <li> The New Australian Bookplate Society “Reviving the lost art of Bookplates”<a href="http://www.bookplatesociety.org.au" target="_blank"> http://www.bookplatesociety.org.au</a> </li>
            </ul>
        <h4>Featured in</h4>
        <ul> 
          <li> 2022 - Exhibit : 1st International Redhood Artstudio Graphic Competition on ex-Libris “Make Love NOT WAR”, Poland.
            We invite you to a virtual exhibition. <a href=" https://www.artsteps.com/view/6263e037caf31468e12dfaeb" target="_blank"> Click here to view </a></li> 
            <li>2021 - DIPLOMA in the International Bookplate Competition TRAKAI 700. IN SEARCH OF IDENTITY: TRAKAI RESIDENT’S DNA, Trakai History Museum, Nr. TDNR 00042, Trakai, 2021 07 29</li>
            <li>2021 - selected for the XVII International Ex Libris - Ex Trains competition and entered the Permanent Collection of the Cabinet of Lyuben Karavelov Regional Library - Ruse, Bulgaria</li>  
            <li>2021 - The Splendour of Modern Heraldic Bookplate Artists Volume 4, Compiled by Dr Bernard A. Juby, Hon. F.H.S., 
              ISBN : 9-781667-157832, France</li>
            <li>2017 - Muestra Internacional De Ex Libris, Seres Fantasticos Que Habitan “El
            Bosque De La Utopia”, Zacatecas, Mexico, 2017</li>
            <li>2017 - SHORTLIST The Wilderness Society of Australia Environment Award for Children’s Literature - "The Cassowary’s Gift”</li>
            <li>2016 - The Cassowary’s Gift by Pam Skadins, illustrated by Kathryn Lovejoy ISBN : 9781925117578, Australia</li>
            <li>2015 - Miedzynarodowa Wystawa Ekslibrisow, Drogi Do Wolnosci, Ekslibrisyrysunek, Grafika, ISBN : 978-83-919987-6-2, Poland, 2015</li>
            <li>2014 - International Contemporary Ex-Libris Artists/-Modern Women Bookplate Designers, published in Portugal 2014 by Artur Mario da Mota Miranda</li>
            <li>2014 - The Artist Showcase, Magazine issue # Spring, Pittsford, NY14534</li>
            <li>2014 - International Contemporary Masters Volume IX, published by World
               Wide Art Books Inc. Santa Barbara CA 93101, USA, 2014</li>
            <a href=" https://www.theleader.com.au/story/1659862/literary-art-formrevived-
            with-bookplates-on-show/" target="_blank"><li> 2013 - The Kogarah Library, July, 2013, Leader
            https://www.theleader.com.au/story/1659862/literary-art-formrevived-
            with-bookplates-on-show/</li>  </a>
            <li>2013 - International Contemporary Masters Volume VII, published by World
                Wide Art Books Inc. Santa Barbara CA 93101 USA, 2013</li>
            <li>2012 - Eileen Webber’s Book of Family and Social History, Special Edition
                noting appreciation for her commissioned ex-libris design, Australia</li>
            <li>2012 - Bookplate Artists and Their Bookplates by Andrew G Peake, published by Tudor Australia Press, 2012, Standard Edition : ISBN - 978-0-9873119-0-
                0, De Luxe Edition : ISBN - 978-0-9873119-1-7</li>
            <li>2012 - Australian Artist, Magazine Issue #341, 2012</li>
            <li>2012 - OUTthere + Regional Business Review, The In-flight magazine of Skytrans April/May, Australia, 2012</li>
            <li>2010 - Important World Artists Volume I, published by World Wide Art Books
               Inc. Santa Barbara CA 93101, USA</li>

        </ul>
      </div>
    </div>
    </div>
  </div>
 
    
    <div class="mobile-about-content" *ngIf="isMobile">
      <ng-container *ngIf="profile | async as profile">

 
      <div class="mobile-about-img" data-class="art" *ngFor="let p of profile">
            
                <app-image [baseUrl]="p.image.baseUrl"></app-image>
           
          </div>
     
      
    </ng-container>
    
      <div class="mobile-publications">
        <h4>Kathryn Elisabeth Lovejoy (1967) – AUSTRALIA <br><br></h4>
        <p>  I was born in Boroko, Port Moresby, Papua New Guinea in November 1967. I moved to Australia with my family after the Independence of Papua New Guinea in 1975. I have practiced art all of my life and established a professional career in 2007.
          <br><br>
          I specialise in ex-libris (bookplate) design, children’s illustrative paintings and themed art. My creative process involves hand-painted works with professional water colours, acrylics and inks, using fine German Hahnemuhle archival canvases and 100% cotton Hahnemuhle papers. 
          <br><br>
          Archival standard reproduction of ex-libris (bookplate) designs and limited edition prints are carried out by my local Brisbane printmaker, whom I have had the pleasure of working with for more than a decade. Colour and capture of the finest detail, with respect to the original hand-painted design, is superb.
          <br><br>
          With regards to commission work, please feel free to email me about the subject you are interested in. As with all commissions, I will collaborate with you individually and with discretion, so that we can work within your means to create a work of art that you will treasure.
          <br><br>
          Sincerely, <br>
          Kathryn </p>

          

      <h4>Member of</h4>
          <ul>
            <li> The New Australian Bookplate Society “Reviving the lost art of Bookplates”<a href="http://www.bookplatesociety.org.au" target="_blank"> http://www.bookplatesociety.org.au</a> </li>
          </ul>
      <h4>Featured in</h4>
      <ul> 
        <li> 2022 - Exhibit : 1st International Redhood Artstudio Graphic Competition on ex-Libris “Make Love NOT WAR”, Poland.
          We invite you to a virtual exhibition. <a href=" https://www.artsteps.com/view/6263e037caf31468e12dfaeb" target="_blank"> Click here to view </a></li> 
          <li>2021 - DIPLOMA in the International Bookplate Competition TRAKAI 700. IN SEARCH OF IDENTITY: TRAKAI RESIDENT’S DNA, Trakai History Museum, Nr. TDNR 00042, Trakai, 2021 07 29</li>
          <li>2021 - selected for the XVII International Ex Libris - Ex Trains competition and entered the Permanent Collection of the Cabinet of Lyuben Karavelov Regional Library - Ruse, Bulgaria</li>
          <li>2021 - The Splendour of Modern Heraldic Bookplate Artists Volume 4, Compiled by Dr Bernard A. Juby, Hon. F.H.S., 
            ISBN : 9-781667-157832, France</li>
          <li>2017 - Muestra Internacional De Ex Libris, Seres Fantasticos Que Habitan “El
          Bosque De La Utopia”, Zacatecas, Mexico, 2017</li>
          <li>2017 - SHORTLIST The Wilderness Society of Australia Environment Award for Children’s Literature - "The Cassowary’s Gift”</li>
          <li>2016 - The Cassowary’s Gift by Pam Skadins, illustrated by Kathryn Lovejoy ISBN : 9781925117578, Australia</li>
          <li>2015 - Miedzynarodowa Wystawa Ekslibrisow, Drogi Do Wolnosci, Ekslibrisyrysunek, Grafika, ISBN : 978-83-919987-6-2, Poland, 2015</li>
          <li>2014 - International Contemporary Ex-Libris Artists/-Modern Women Bookplate Designers, published in Portugal 2014 by Artur Mario da Mota Miranda</li>
          <li>2014 - The Artist Showcase, Magazine issue # Spring, Pittsford, NY14534</li>
          <li>2014 - International Contemporary Masters Volume IX, published by World
             Wide Art Books Inc. Santa Barbara CA 93101, USA, 2014</li>
          <a href=" https://www.theleader.com.au/story/1659862/literary-art-formrevived-
          with-bookplates-on-show/" target="_blank"><li> 2013 - The Kogarah Library, July, 2013, Leader
          https://www.theleader.com.au/story/1659862/literary-art-formrevived-
          with-bookplates-on-show/</li>  </a>
          <li>2013 - International Contemporary Masters Volume VII, published by World
              Wide Art Books Inc. Santa Barbara CA 93101 USA, 2013</li>
          <li>2012 - Eileen Webber’s Book of Family and Social History, Special Edition
              noting appreciation for her commissioned ex-libris design, Australia</li>
          <li>2012 - Bookplate Artists and Their Bookplates by Andrew G Peake, published by Tudor Australia Press, 2012, Standard Edition : ISBN - 978-0-9873119-0-
              0, De Luxe Edition : ISBN - 978-0-9873119-1-7</li>
          <li>2012 - Australian Artist, Magazine Issue #341, 2012</li>
          <li>2012 - OUTthere + Regional Business Review, The In-flight magazine of Skytrans April/May, Australia, 2012</li>
          <li>2010 - Important World Artists Volume I, published by World Wide Art Books
             Inc. Santa Barbara CA 93101, USA</li>


        </ul>
      </div>
     
    </div>


 